export default "__VITE_ASSET__28ce045a__"